'use client';

import '@/app/global.css';

import { Lato, Lustria } from 'next/font/google';
import { DatadogAppRouter } from '@datadog/browser-rum-nextjs';
import ErrorScreen from '@/components/layout/ErrorScreen';

const lato = Lato({
  subsets: ['latin'],
  weight: ['400', '700', '900'],
  variable: '--font-lato',
  display: 'swap'
});

const lustria = Lustria({
  subsets: ['latin'],
  weight: ['400'],
  variable: '--font-lustria',
  display: 'swap'
});

/**
 * Catches errors thrown by the root layout itself, which the segment-level
 * error.js boundaries cannot reach. This is important for Datadog.
 */
export default function GlobalError({ error }) {
  return (
    <html
      lang="en-us"
      className={`${lustria.variable} ${lato.variable} h-full`}
    >
      <body className="font-lato bg-white text-black">
        <DatadogAppRouter />
        <ErrorScreen error={error} />
      </body>
    </html>
  );
}
